import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
import { updateUser } from "../actions/users";
import { signOut } from "../Api/index";

// Logs out of the shared login (every app in this browser)
export default function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return async () => {
    const user = JSON.parse(secureLocalStorage.getItem("profile") || "null");
    const id = toast.loading("Logging you out...");
    try {
      await Promise.allSettled([
        dispatch(updateUser(user?.results?._id, { login: "no", system: "none" })),
        signOut(),
      ]);
    } finally {
      dispatch({ type: "LOGOUT" });
      toast.remove(id);
      navigate("/stock/login");
    }
  };
}
